<template>
    <div class="project-type-skills">
        <div class="row">
            <div class="col-lg-4">
                <div class="placeholder">
                    <div class="placeholder__heading">
                        <d-tooltip placement="left" identifier="projects.projectTypeSkills" />
                        Hvilke svende er gode til hvilke opgaver?
                    </div>
                    <div class="placeholder fit-content">

                        <vue-good-table
                            :columns="columns"
                            :rows="rows"
                            :search-options="searchOptions"
                            :pagination-options="paginationOptions"
                            :sort-options="sortOptions"
                            :styleClass="styleClass"
                            @on-row-click="selectEmployee"
                            :row-style-class="selectedRowClass"
                            v-if="!loading"
                        >
                            <div slot="emptystate">
                                Ingen data ...
                            </div>
                            <template slot="table-row" slot-scope="props">
                                <div v-if="props.column.field == 'type.name'" class="table-column__description" :title="props.row.type ? props.row.type.name : '-'">
                                    {{ props.row.type ? props.row.type.name : '-' }}
                                </div>
                                <div v-else :title="props.formattedRow[props.column.field]">
                                    {{ props.formattedRow[props.column.field] }}
                                </div>
                            </template>
                        </vue-good-table>

                        <box-loading height="350" v-else />

                    </div>
                </div>
            </div>
            <div class="col-lg-8">
                <div class="info" v-if="!selectedRow">
                    Vælg en opgavetype for at se hvilke medarbejdere, der er gode til denne
                </div>
                <project-type-skills-single :data="selectedRow" v-else />
            </div>
        </div>
    </div>
</template>

<script>
import * as projectTypeService from '@/services/projectTypeService'

export default {
    data () {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [
                /* { label: 'Initialer', field: 'initials', type: 'string' }, */
                { label: 'Opgavetype', field: 'name', type: 'string' }
                /* { label: 'Omsætning', field: 'invoices_total', type: 'number' },
                { label: 'DB', field: 'coverage', type: 'number' },
                { label: 'DG', field: 'coverage_percent', type: 'number' },
                { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' } */
            ],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
                /* initialSortBy: {
                    field: 'invoices_total',
                    type: 'desc'
                } */
            },
            styleClass: 'vgt-table'
        }
    },
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.loading = true
            this.$emit('finishedLoading', null)
            this.selectedRow = null
            let params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            }
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid
            }
            projectTypeService.projectTypeSkills(params, (response) => {
                this.rows = response.data
                this.$emit('finishedLoading', this.rows.length)
                this.loading = false
            }, (err) => {
                console.log(err)
                this.loading = false
            })
        },
        selectEmployee (projectType) {
            this.selectedRow = projectType.row
            console.log(projectType.row)
        },
        selectedRowClass (row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected'
            }
        }
    },
    components: {
        'project-type-skills-single': require('./projectTypeSkillsSingle.vue')
    },
    computed: {
        globalParams () {
            let startDate = this.$store.getters.getStartDate
            let endDate = this.$store.getters.getEndDate
            let department = this.$store.getters.getCurrentDepartment.uuid
            return startDate + endDate + department
        }
    },
    watch: {
        globalParams: function () {
            this.getData()
        }
    }
}
</script>



// WEBPACK FOOTER //
// projectTypeSkills.vue?b6bba9ea